import axios from './axios';
import config from '../../helpers/config';

export default (designId, itemId, quantity) => (
  axios.post(`${config.designBuilderLoadDesignPath}/${designId}/items/${itemId}/quantity/${quantity}`)
);
